// src/features/participants/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import Customer from './pages/customer/Customer';
import CustomerForm from './pages/customer/CustomerForm';
import Detail from './pages/customer/Detail';
import UserForm from './pages/customer/UserForm';
import CompanyForm from '../participants/pages/company/CompanyForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const customerPageRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customer',
    component: Customer,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CUSTOMERS.SEARCH_CUSTOMER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const customerFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customer/form',
    component: CustomerForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CUSTOMERS.SAVE_CUSTOMER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});


export const customerDetailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customer/detail',
    component: Detail,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.CUSTOMERS.GET_CUSTOMER_BY_DETAIL || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const customerUserFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customer/detail/user',
    component: UserForm,
});

export const companyFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customer/detail/company',
    component: CompanyForm,
});

export const customerRoutes = [
    customerPageRoute,
    customerFormRoute,
    customerDetailRoute,
    customerUserFormRoute,
    companyFormRoute,
];